import { render, staticRenderFns } from "./WhatsAppSetting.vue?vue&type=template&id=1cb3c103&scoped=true"
import script from "./WhatsAppSetting.vue?vue&type=script&lang=js"
export * from "./WhatsAppSetting.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppSetting.vue?vue&type=style&index=0&id=1cb3c103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3c103",
  null
  
)

export default component.exports